export const PICKER_DROPDOWN_RESULTS_MAX_PX = 192;
export const PICKER_DROPDOWN_CREATE_LINE_PX = 56;
export const PICKER_DROPDOWN_MARGIN_PX = 8;
export const PICKER_DROPDOWN_SAFE_GAP_PX = 16;

export const estimatePickerDropdownHeight = (hasCreateLine: boolean, resultsMaxHeight: number = PICKER_DROPDOWN_RESULTS_MAX_PX): number =>
    PICKER_DROPDOWN_MARGIN_PX
    + resultsMaxHeight
    + (hasCreateLine ? PICKER_DROPDOWN_CREATE_LINE_PX : 0)
    + PICKER_DROPDOWN_SAFE_GAP_PX;

export const resolvePickerClipBounds = (
    viewportHeight: number,
    parentRect?: { top: number; bottom: number }
): { top: number; bottom: number } => ({
    top: parentRect ? Math.max(0, parentRect.top) : 0,
    bottom: parentRect ? Math.min(viewportHeight, parentRect.bottom) : viewportHeight
});

export const shouldOpenPickerDropdownUpwards = (
    pickerTop: number,
    pickerBottom: number,
    clip: { top: number; bottom: number },
    dropdownHeight: number
): boolean => {
    const spaceBelow = clip.bottom - pickerBottom;
    const spaceAbove = pickerTop - clip.top;
    return spaceBelow < dropdownHeight && spaceAbove > spaceBelow;
};

export const PICKER_DROPDOWN_MIN_FITTED_RESULTS_PX = 128;

export const findPickerClippingAncestor = (element: HTMLElement | null): HTMLElement | undefined => {
    let current = element?.parentElement;
    while (current && current !== document.body) {
        const overflowY = window.getComputedStyle(current).overflowY;
        if (overflowY !== 'visible') {
            return current;
        }
        current = current.parentElement;
    }
    return undefined;
};

export const fitPickerResultsHeight = (
    spaceBelow: number,
    hasCreateLine: boolean,
    minHeight: number = PICKER_DROPDOWN_MIN_FITTED_RESULTS_PX
): number => Math.max(
    minHeight,
    Math.floor(spaceBelow - PICKER_DROPDOWN_MARGIN_PX - (hasCreateLine ? PICKER_DROPDOWN_CREATE_LINE_PX : 0) - PICKER_DROPDOWN_SAFE_GAP_PX)
);
